module.exports = __webpack_public_path__ + "img/35-config-usuarios-lista.c97762b3.png";